'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _lv_LV = require('../../date-picker/locale/lv_LV');

var _lv_LV2 = _interopRequireDefault(_lv_LV);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

exports['default'] = _lv_LV2['default'];